import type { Answers } from '@/redux/slider';
import SeePriceMain from '@/modals/see-price/see-price-main';
import { store } from '@/redux/store';
import { ConfigSlice } from '@/redux/config';
import { ModalSlice } from '@/redux/modal';
import { SliderSlice } from '@/redux/slider';
import Track from '@/utils/track';
import { goToOvm } from '@/utils/ovm-iusta';

export const goToSosOvmOrShowPriceDialog = (): void => {
  const appendPoaToCTA = ConfigSlice.selectors.appendPoaToCTA(store.getState());
  const showPriceModal = ConfigSlice.selectors.showPriceModal(store.getState());
  const showPriceModalInsuranceCondition = ConfigSlice.selectors.showPriceModalInsuranceCondition(store.getState());
  const answersDirect = SliderSlice.selectors.answersDirect(store.getState());

  Track.Experiments.SeePriceCtaButtonLongRead(answersDirect);

  const checkForShowPriceModalConditions = (showPriceModalInsuranceCondition: Answers) => {
    const legalInsuranceAnswer = answersDirect.legal_insurance;
    if (!showPriceModalInsuranceCondition || !legalInsuranceAnswer) return true;
    return Object.keys(showPriceModalInsuranceCondition).indexOf(legalInsuranceAnswer) >= 0;
  };

  if (showPriceModal && checkForShowPriceModalConditions(showPriceModalInsuranceCondition)) {
    store.dispatch(
      ModalSlice.actions.openModal({
        main: <SeePriceMain />,
      }),
    );
  } else {
    void goToOvm(appendPoaToCTA, answersDirect);
  }
};
